import { Modal, Tooltip } from 'antd';
import React, { useState } from 'react';
import { RiDeleteBin5Line } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Apis from '../../../../api';
import { HEADERMENU_PATH } from '../../../../routes/RoutesURL';
import HSButton from '../../../common/Button';
import MessageActions from '../../../message/redux/actions';

type Props = {
    investmentUUID: string;
};

const CancelInvestmentModal: React.FC<Props> = ({ investmentUUID }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const onClickCancel = () => {
        setOpen(false);
    };

    const onConfirm = () => {
        setLoading(true);
        Apis.withdraw(investmentUUID)
            .then(() => {
                navigate(HEADERMENU_PATH.investments);
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: false, text: String(err) }));
            })
            .finally(() => {
                setLoading(false);
                onClickCancel();
            });
    };

    return (
        <>
            <Tooltip title="Cancel">
                <RiDeleteBin5Line size="1.2rem" className="cursor-pointer" onClick={() => setOpen(true)} />
            </Tooltip>
            <Modal
                open={open}
                title="Cancel Investment"
                footer={null}
                onCancel={onClickCancel}
                onOk={onClickCancel}
                centered
            >
                <p className="text-base">Are you sure, you want to cancel this Investment Commitment?</p>
                <div className="flex justify-center items-center mt-4">
                    <HSButton light title="Cancel" onClick={onClickCancel} className="mr-2" />
                    <HSButton title="Confirm" loading={loading} onClick={onConfirm} />
                </div>
            </Modal>
        </>
    );
};

export default CancelInvestmentModal;
